import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import formdata from './formdata'

const state = {
    data: {
        name:'',
        number:'',
        specification_id: null,
        supplier_id:null,
        entitycategory_id: null,
        tag_ids:[],
        company_ids:[],
        recipesteps:[],
        logo_ids:[],
        logos:null,
        duplicate:false
    },
    entities:[],
    ingredients:[],
    showresult:null
    
};

export default {
    modules: {
        formdata: formdata,
        
    },
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};